import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { strategiesQuery } from '@/features/strategy/strategy-api';
import { StrategyScreen } from '@/features/strategy/strategy-screen';
import { walletsQuery } from '@/features/wallet/wallet-api';

export const Route = createFileRoute('/_app/settings/copy')({
  validateSearch: z.object({
    s: z
      .string()
      .regex(/^[a-f0-9]{24}$/)
      .optional(),
  }),
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(strategiesQuery),
      context.queryClient.ensureQueryData(walletsQuery),
    ]),
  component: StrategyRoute,
});

function StrategyRoute() {
  const { s } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { data: strategies } = useSuspenseQuery(strategiesQuery);
  const { data: wallets } = useSuspenseQuery(walletsQuery);
  return (
    <StrategyScreen
      strategies={strategies}
      wallets={wallets}
      selectedId={s}
      onSelect={(id) => void navigate({ search: { s: id }, replace: true })}
      onDeleted={() => void navigate({ search: {}, replace: true, ignoreBlocker: true })}
    />
  );
}
